import { render } from "./App.vue?vue&type=template&id=1a267297"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "Assets/styles.css?vue&type=style&index=0&lang=css"
script.render = render

export default script